<div class="add-70">
    <div class="small-banner">
        <div class="container align-items-center flex-wrap h-100" style="display: grid;">
                <h2 class="font-600 text-center">
                    Ask Us Anything
                </h2>
        </div>
    </div>
</div>
<br>
<app-client-marquee></app-client-marquee>
<div class="page-section">
    <div class="container">
        <div class="card contact-us-card">
            <div class="card-body">
                <div class="row align-items-center flex-wrap h-100">
                    <div class="col-md-6">
                        <h3 class="font-600 mt-2" style="font-size: 1.5rem;">
                            We're not doctors, But we're pretty good at diagnosing your system.
                        </h3>
                        
                        <div class="contactus-details-right enquiry-form">
                            <form #requestForm="ngForm">
        
                                <div class="con-tac">
        
                                    <div class="input" *ngIf="!success_sent">
                                        <input tabindex="1" required id="contact-name" type="text" name="name" class="input-field" [(ngModel)]="request_demo_info.name" #fullPatientName="ngModel" placeholder="" #nameit />
                                        <label for="contact-name" class="input-label">Name<span class="required-marker">*</span></label>
        
                                        <!-- <div class="form-text warning" *ngIf="fullPatientName.touched && fullPatientName.errors?.required && !success_sent">
                                            Name is required!
                                        </div> -->
                                    </div>
        
        
                                    <div class="input" *ngIf="!success_sent">
                                        <input tabindex="2" required id="contact-organizationId" type="text" name="organization" class="input-field" [(ngModel)]="request_demo_info.organization" #Organization="ngModel" placeholder="" #orgnizationit />
                                        <label for="contact-organizationId" class="input-label">Organization<span class="required-marker">*</span></label>
        
                                        <!-- <div class="form-text warning" *ngIf="Organization.touched && Organization.errors?.required && !success_sent">
                                            Organization is required!
                                        </div> -->
                                    </div>
        
        
                                    <div class="input" *ngIf="!success_sent">
                                        <input tabindex="3" required id="contact-email" pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$" name="email" class="input-field" [(ngModel)]="request_demo_info.email" #fullemail="ngModel"
                                            placeholder="" />
                                        <label class="input-label" for="contact-email">Email<span class="required-marker">*</span></label>
        
                                        <!-- <div class="form-text warning" *ngIf="fullemail.touched && fullemail.errors?.required && !success_sent">
                                            Email is required!
                                        </div> -->
                                        <div class="form-text warning" *ngIf="fullemail.touched && fullemail.errors?.pattern ">
                                            Email is invalid!
                                        </div>
                                    </div>
        
        
                                    <div class="input" *ngIf="!success_sent">
                                        <input tabindex="4" required id="contct-phone" type="text" name="phone" class="input-field" [(ngModel)]="request_demo_info.phone" #fullcontactnumber="ngModel" pattern="^[6-9]\d{9}$" placeholder="" />
                                        <label for="contct-phone" class="input-label">Mobile<span class="required-marker">*</span></label>
        
                                        <!-- <div class="form-text warning" *ngIf="fullcontactnumber.touched && fullcontactnumber.errors?.required && !success_sent">
                                            Contact number is required!
                                        </div> -->
                                        <div class="form-text warning" *ngIf="fullcontactnumber.errors?.pattern">
                                            Invalid mobile number
                                        </div>
                                    </div>
        
        
                                    <div class="input" *ngIf="!success_sent">
                                        <input tabindex="5" type="text" id="contact-location" class="input-field" required placeholder="" name="location" [(ngModel)]="request_demo_info.location" #fulllocation="ngModel">
                                        <label for="contact-location" class="input-label">Location<span class="required-marker">*</span></label>
        
                                        <!-- <div class="form-text warning" *ngIf="fulllocation.touched && fulllocation.errors?.required && !success_sent">
                                            Location is required!
                                        </div> -->
                                    </div>
        
                                    <div class="input" *ngIf="!success_sent">
                                        <textarea tabindex="6" class="input-field" placeholder="" name="message" id="message" [(ngModel)]="request_demo_info.message"></textarea>
                                        <label for="message" class="input-label">Message</label>
        
                                    </div>
        
                                    <br>
                                    <div class="text-center mb-2">
                                        <div class="alert alert-success" role="alert" *ngIf="success_sent">Submitted Successfully!</div>
                                        <button *ngIf="!success_sent" style="width: 100%;" type="submit" value="submit" class="btn button brand-button" name="submit_request" (click)="submitRequest();" [disabled]="isInvalid()"><i *ngIf="login_spinner" class="fas fa-spinner animate-spinner"></i> Submit</button>
                                    </div>
        
                                </div>
                                <!-- con-tac -->
                            </form>
                            <!-- contactus-details-right -->
                        </div>
                    </div>
                    <div class="col-md-6">
                        <img src="assets/img/cta.svg" alt="" class="flip-x">
                    </div>
                </div>
            </div>
        </div>
        <div class="card details-card">
            <div class="card-body">
                <div class="row ">
                    <div class="col-lg-4 col-12 hover-pointer contact-stack" (click)="openMaps()">
                        <div class="row align-items-center flex-wrap h-100">
                            <div class="col-4 text-center">
                                <img src="assets/img/location-icon.svg" alt="">
                            </div>
                            <div class="col-8">
                                <p class="font-600">
                                    OFFICE ADDRESS
                                </p>
                                <p>1/1A, C-20, Coast Guard Golf Ground Rd, C Block, Phase 2, Industrial Area, Sector 62, Noida, Uttar Pradesh 201309</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-12 hover-pointer contact-stack" (click)="openDialer()">
                        <div class="row align-items-center flex-wrap h-100">
                            <div class="col-4 text-center">
                                <img src="assets/img/contact-icon.svg" alt="">
                            </div>
                            <div class="col-8">
                                <p class="font-600">
                                    CONTACT
                                </p>
                                <p>+91 97112 01611</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-12 hover-pointer contact-stack" (click)="openEmail()">
                        <div class="row align-items-center flex-wrap h-100">
                            <div class="col-4 text-center">
                                <img src="assets/img/email-icon.svg" alt="">
                            </div>
                            <div class="col-8">
                                <p class="font-600">
                                    EMAIL ADDRESS
                                </p>
                                <p>info@nuvertos.com</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>